import {Component} from 'san';

import styles from './style/index.module.less';
import Img from './components/img';
import Video from './components/video';
import Audio from './components/audio';
import Vote from './components/vote';
import Report from './components/report';

export default class Article extends Component {
    // bca-disable
    static template = require('./index.html');
    static components = {
        'ui-img': Img,
        'ui-video': Video,
        'ui-audio': Audio,
        'ui-vote': Vote,
        'ui-report': Report
    };
    static computed = {
        itemData() {
            return this.data.get('data.itemData');
        },
        isBaijiahao() {
            return this.data.get('itemData.notice.isBaiJiaHao') === 1;
        },
        showSrc() {
            return this.data.get('itemData.readsrc.forbidden') === 0;
        }
    };
    static filters = {
        typeClass(type) {
            if (type !== 'text') {
                type = 'media';
            }
            type += 'Wrap';
            return this.data.get('styles')[type];
        }
    }
    initData() {
        return {
            styles
        };
    }
    attached() {
        const showSource = !this.data.get('isBaijiahao')
                        && this.data.get('showSrc');
        if (showSource) {
            this.storeDispatch('readSrc:showLog');
        }

        // 处理下奇怪的<a target="_blank" href="xxxx">yyyy</a> 场景
        const aList = [...document.querySelectorAll(`.${styles.textWrap} a`)];
        for (const a of aList) {
            if (a.getAttribute('href')
                && a.getAttribute('href').indexOf('javascript:') >= 0
                && a.getAttribute('target')
            ) {
                a.removeAttribute('target');
            }
        }
    }
    srcClkHandler() {
        this.storeDispatch('readSrc:clkLog');
    }
}
